


















































































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IClientProviderData } from "@/models/providers/client";
import { IAccount } from "@/models/accounts";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "affiliate-provider": () =>
      import("@/components/app/global/affiliate/affiliateProvider.vue"),
    "affiliate-stats-grid": () =>
      import("@/components/app/global/affiliate/statsGrid.vue"),
    "affiliates-customer-controls-warning": () =>
      import(
        "@/components/app/global/affiliate/affiliatesCustomerControlsWarning.vue"
      )
  }
})
export default class AdminClientAffiliateView extends Vue {
  // Inject

  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => any;

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: false })
  public client!: IClient;

  // Computed

  public get isStaged() {
    return this.$clientProvider().isStaged;
  }
}
